import type { UploaderAPI } from "./interface";
import { createContext, useContextSelector } from "use-context-selector";

export const UploaderContext = createContext<UploaderAPI | undefined>(
  undefined
);

export function useUploaderContext<T>(
  selector: (api: UploaderAPI) => T,
  component?: string
): T {
  const value = useContextSelector(UploaderContext, (ctx) => {
    if (!ctx) {
      const err = new Error(
        `<${
          component ?? "component"
        } /> is missing a parent <UploaderContext.Provider /> component.`
      );
      if (Error.captureStackTrace)
        Error.captureStackTrace(err, useUploaderContext);
      throw err;
    }
    return selector(ctx);
  });
  return value;
}

export const useUploaderItems = () => useUploaderContext((api) => api.items);
export const useRemoveUploadedItem = () =>
  useUploaderContext((api) => api.removeItem);
export const useUpload = () => useUploaderContext((api) => api.upload);
